var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ValidationProvider',{ref:"checkout.customer.address.country",attrs:{"name":"user.country","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-autocomplete',{staticClass:"text-field country-autocomplete",attrs:{"value":_vm.userCountry,"items":_vm.countryList,"outlined":"","hide-details":"","hide-no-data":"","dense":"","item-text":"country","item-value":"country_iso2","label":_vm.$t('fields.user.country'),"error-messages":errors[0],"attach":".country-autocomplete","menu-props":{
      contentClass: 'menu--select',
      bottom: true,
      offsetY: true,
      nudgeBottom: 0,
    }},on:{"change":function($event){return _vm.$emit('countrySelected', $event)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }